export enum PaymentStatus {
  Unpaid = 0,
  Paid = 1,
  Refund = 2,
}
